// const devicePix = window.window.devicePixelRatio
const w = window.innerWidth
const d = parseFloat(w/375).toFixed(2)
const changeImgSizeFn = async(url, obj, imgWidthSize) => {
  var img = new Image();
  img.src = url;
  let res = {};
  img.onload = function() {
    res = {
      width: img.width,
      height: img.height,
    };
    const imgObj = obj
    if (imgWidthSize > res.width) {
      // 大于宽度进行压缩  小于宽度原尺寸
      imgObj.src = img.src;
    }

    let realHeight = (imgWidthSize / res.width) * res.height/2*d;
    imgObj.src = img.src
    imgObj.style.height = `${realHeight}px`;
  };
};
export {
  changeImgSizeFn
}
